// Toggle logic for sidebar category menu
if (document.querySelectorAll('.content-catergories').length) {
  const categoryContainer = document.querySelector('.content-catergories');
  const categoryItems = categoryContainer.querySelectorAll('.content-catergories__single');

  categoryItems.forEach((item) => {
    // Only add click handler to items with children (have the 'ac' class)
    if (item.classList.contains('ac')) {
      const topElement = item.querySelector('.content-catergories__single__top');
      
      if (topElement) {
        topElement.addEventListener('click', (e) => {
          // Prevent default if clicking on the h3 (but allow links to work normally)
          if (e.target.tagName === 'H3' || e.target.closest('h3')) {
            e.preventDefault();
          }
          
          // Don't toggle if clicking on a link
          if (e.target.tagName === 'A' || e.target.closest('a')) {
            return;
          }

          // Toggle is-active on clicked item
          item.classList.toggle('is-active');
        });
      }
    }
  });
}

